export const DEFAULT_PERIOD_VALUE = '';